<template>
  <div>
    <div
      class="border-b border-ontick-steel-300 dark:border-ontick-graphite-700"
    >
      <h2 class="text-ontick-carbon-900 dark:text-gray-300">
        {{ title }}
      </h2>
    </div>
    <transition-group
      v-on:enter="enter"
      v-on:leave="leave"
      v-bind:css="false"
      appear
    >
      <div
        v-for="(item, index) in list"
        :key="index"
        v-show="index < limitBy"
        @click="$emit('selected', item, type)"
        class="checkbox flex cursor-pointer items-center py-1"
        :class="
          all_filters.includes(item) ? 'bg-ontick-steel-100' : 'bg-gray-50'
        "
      >
        <div class="border">
          <div
            class="inner"
            :class="all_filters.includes(item) ? 'checked' : ''"
          >
            <span
              v-show="all_filters.includes(item)"
              class="h-3 w-3 text-ontick-graphite-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                /></svg
            ></span>
          </div>
        </div>
        <p
          :class="
            all_filters.includes(item)
              ? 'text-ontick-carbon-700 dark:text-white'
              : 'text-ontick-carbon-900 dark:text-gray-400'
          "
          class="mx-3 text-sm"
        >
          {{ item }}
        </p>
      </div>
    </transition-group>
    <div class="flex justify-center py-3">
      <button
        v-show="limitBy == 5"
        @click="$emit('max', list.length - 1)"
        class="text_button"
      >
        <span class="mr-2 text-ontick-blue-500" v-html="$icons.plus"></span> Ver
        mais
      </button>
      <button
        v-show="limitBy > 5"
        @click="$emit('minus', 5)"
        class="text_button"
      >
        <svg
          class="mr-2"
          xmlns="http://www.w3.org/2000/svg"
          height="24px"
          viewBox="0 0 24 24"
          width="24px"
          fill="#07a4ff"
        >
          <path d="M0 0h24v24H0V0z" fill="none" />
          <path d="M19 13H5v-2h14v2z" />
        </svg>
        Ver menos
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String },
    list: { type: Array },
    all_filters: { type: Array },
    limitBy: { type: Number },
    type: { type: String },
  },

  methods: {
    enter(el, done) {
      TweenMax.fromTo(
        el,
        0.5,
        {
          autoAlpha: 0,
          scale: 1.5,
        },
        {
          autoAlpha: 1,
          scale: 1,
          transformOrigin: "50% 50%",
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        0.5,
        {
          autoAlpha: 1,
          scale: 1,
        },
        {
          autoAlpha: 0,
          scale: 0.8,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox {
  @apply my-2  rounded-md p-3 dark:bg-ontick-graphite-500;
}
$checkbox-size: 16px;
.checkbox > .border {
  width: $checkbox-size;
  height: $checkbox-size;
  box-sizing: border-box;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  @apply rounded border-2 border-ontick-blue-600 dark:border-gray-300;
}
.checkbox > .border > .inner {
  transition: 0.2s all linear;
  background-color: #07a4ff;
  width: 0px;
  height: 0px;
}
.checkbox > .border .checked {
  transition: 0.2s width height linear;
  width: $checkbox-size;
  height: $checkbox-size;
  @apply rounded;
}

.text_button {
  @apply flex items-center text-center text-sm text-ontick-carbon-900 dark:text-gray-400;
}
</style>
